import React from 'react'
import ModalWrapper from 'components/modals/ModalWrapper'
import PropTypes from 'prop-types'
import { withStyles } from '@material-ui/core/styles'
import Typography from '@material-ui/core/Typography'
import Grid from '@material-ui/core/Grid'
const styles = theme => ({})
class DeleteCycleModal extends React.Component {
  static propTypes = {
    transaction: PropTypes.object.isRequired,
    cycle: PropTypes.object.isRequired,
    removeCycle: PropTypes.func.isRequired,
    hideModal: PropTypes.func
  }

  handleDelete = () => {
    const { transaction, cycle } = this.props
    this.props.removeCycle(transaction, cycle)
  }
  componentDidMount() {}
  render() {
    const { cycle, transaction } = this.props
    const title =
      cycle.key === transaction.pool.cycles.length - 1
        ? 'Cycle en cours'
        : `Cycle ${cycle.key + 1}`
    return (
      <ModalWrapper
        open
        hideModal={this.props.hideModal}
        onOk={this.handleDelete}
        maxWidth={'xs'}
        title={`Supprimer ${title}`}
        okText="Supprimer"
        okDisabled={false}>
        <Grid container direction="column" justify="center">
          <Grid item xs={12}>
            <Typography variant="subheading" gutterBottom>
              {`Êtes-vous sur de vouloir supprimer le ${title}`}
              <Typography variant="caption">
                Cette action est irréversible
              </Typography>
            </Typography>
          </Grid>
        </Grid>
      </ModalWrapper>
    )
  }
}

export default withStyles(styles)(DeleteCycleModal)



// WEBPACK FOOTER //
// ./src/components/modals/client/DeleteCycleModal.js